var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chat-container-h5"},[_c(_setup.MessageList),_c(_setup.ChatEditor)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }